/*** TOP PROGRESS BAR .JS ***/
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],f.push(null==a[d]&&"function"!=typeof e?a[d]=e:void 0)}catch(g){c=g}return f},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);

var AT_Main = {

	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE
			myWidth = window.innerWidth;
		}
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
			//IE 6+ in 'standards compliant mode'
			myWidth = document.documentElement.clientWidth;
		}
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
			//IE 4 compatible
			myWidth = document.body.clientWidth;
		}

		return myWidth;
	}

	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .d-sm-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .d-md-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .d-lg-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .d-xl-block").css("display") == "block")
			return 4; //desktop layout
	}

	,homeSlideshow : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){

                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                	_delay_time = jQuery(value).data('time');
                }

                var swiper = new Swiper('.swiper-container', {
                  	autoplay: _delay_time
                  	,loop: true
                    ,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: jQuery(value).data('animation')
                  	,setWrapperSize: false
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });

                        });
                    }
                });
            });
        }
    }

  	,homeIE : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){

                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                  _delay_time = jQuery(value).data('time');
                }

                var swiper = new Swiper('.swiper-container', {
                    autoplay: _delay_time
                  	,loop: true
                  	,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: 'fade'
                  	,setWrapperSize: true
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });

                        });
                    }
                });
            });
        }
    }

	,stickMenu : function() {
		var enable_stick = jQuery(".header-content").data('stick');
		var	enable_stick_mobile = jQuery(".header-content").data('stickymobile');
		if(enable_stick){
		  //Keep track of last scroll
			var lastScroll = 0;
			var header = jQuery(".header-container");
			var body_content = jQuery("#body-content");
          	var blank_space = jQuery(".blankspace");
			var zoomLogo = jQuery(".header-logo");

			jQuery(window).scroll(function() {
				//Sets the current scroll position
				var st = jQuery(this).scrollTop();
				//Determines up-or-down scrolling
				if (st > lastScroll) {

					//Replace this with your function call for downward-scrolling
					if (st > 200 ) {
						header.addClass("header-fixed");
						body_content.addClass("has-header-fixed");
                   		blank_space.addClass("add-blank-space");
                      	zoomLogo.addClass("ZoomLogoHeader");
					}
				}
				else {
					//Replace this with your function call for upward-scrolling
					if (st < 200) {
						header.removeClass("header-fixed");
						body_content.removeClass("has-header-fixed");
                      	blank_space.removeClass("add-blank-space");
                      	zoomLogo.removeClass("ZoomLogoHeader");
					}
				}
				//Updates scroll position
				lastScroll = st;
			});
		}
    	if(enable_stick_mobile && AT_Main.getWidthBrowser() < 992){
		  //Keep track of last scroll
			var lastScroll = 0;
			var header = jQuery(".header-container");
			var body_content = jQuery("#body-content");
          	

			jQuery(window).scroll(function() {
				//Sets the current scroll position
				var st = jQuery(this).scrollTop();
				//Determines up-or-down scrolling
				if (st > lastScroll) {
					
					//Replace this with your function call for downward-scrolling
					if (st > 250 ) {
						header.addClass("header-mobile-fixed fadeInDown animated");
						body_content.addClass("has-header-fixed");
                      	
					}
				}
				else {
					//Replace this with your function call for upward-scrolling
					if (st < 250) {
						header.removeClass("header-mobile-fixed fadeInDown animated");
						body_content.removeClass("has-header-fixed");
                      	
					}
				}
				//Updates scroll position
				lastScroll = st;
			});
		}
	}

    ,fixNavHeader : function() {
      var _header_style = parseInt(jQuery(".header-container").data('style'));

      if(_header_style == 4 || _header_style == 4){
        jQuery('.mobile-version').removeClass('d-lg-none');
        jQuery('.mobile-version').addClass('d-xl-none');
      }

      if(_header_style == 7){
        jQuery('.mobile-version').removeClass('d-lg-none');
      }

    }

	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) {
				var d = b + c / 2;
			}
			else {
				var d = 1 ;
			}

			if (d < 1000 && d < c) {
				jQuery("#scroll-to-top").removeClass('on off').addClass('off');
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on');
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}

	,mailchipPopup : function(){
      
	}

    ,toggleVerticalMenu : function(){
      
      jQuery(document).on('click', '.vertical-menu .head', function(e) {
        jQuery(this).parent().toggleClass('opened');
      });
	  // Add Vertical menu to Slideshows Section
      $('.wrap-breadcrumb .vertical-menu .navbar').appendTo("#slide-shows .vertical-menu .navigation");
      
      // Hide Vertical menu when hide vertical breakcrumb 
      

	}

    ,toggleCartSidebar : function(){

        jQuery('.am-close, .addcart-overlay').on('click',function (e) {
          jQuery('#layer-addcart-modal').removeClass('show');
        });

        jQuery('.cart-sb .c-close').on('click',function () {
          AT_Main.fixNoScroll();
          jQuery('.cart-sb').removeClass('opened');
          jQuery('html,body').removeClass('cart-opened');
        });
    }

  	,toggleFilterSidebar : function(){
        jQuery('.filter-icon.toggle').on('click',function (e) {
            jQuery('.filter-sidebar.position-body').slideToggle("slow");
        });
      
		jQuery('.filter-icon.drawer').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('body').toggleClass('sidebar-opened');
		});	
      
      	jQuery('.f-close').on('click',function () {
          	jQuery('#sidebar').removeClass('opened');
			jQuery('html,body').removeClass('sidebar-opened');
			AT_Main.fixReturnScroll();
		});
      
      	jQuery('.filter-icon-order').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('body').toggleClass('order-sidebar-opened');
		});

      	jQuery('.fof-close').on('click',function () {
			jQuery('html,body').removeClass('order-sidebar-opened');
			AT_Main.fixReturnScroll();
		});
	}

    ,parallaxIt : function() {
		if($(".parallax-section").length == 0)
			return;
		$.fn.parallaxScroll = function(xpos, speedFactor, outerHeight) {
			var elem = $(this);
			var getHeight;
			var firstTop;
			var paddingTop = 0;

			//get the starting position of each element to have parallax applied to it
			$(this).each(function(){
				firstTop = $(this).offset().top;
			});

			getHeight = function(jqo) {
				return jqo.outerHeight(true);
			};

			var j$element, top, height, pos;

			function update(){

				pos = $(window).scrollTop();
				firstTop = elem.offset().top;
				height = getHeight(elem);

				if (pos + $(window).height() < firstTop || pos > firstTop + height) {
				  return;
				}

				if(AT_Main.checkLayout()!=1)
				  elem.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px",0);
				else
				  elem.css('backgroundPosition', xpos + " " + -Math.round((firstTop - pos) * speedFactor) + "px",0);
			}

			window.addEventListener('scroll', function(){
				update();
			}, false)

			update();
		};

		$(".parallax-section").parallaxScroll("50%",0.1);
	}

    ,handleGridList : function(){
        if ($.cookie('view-cata-list') == "yes") {
            $("body").addClass("view-cata-list");
          	$(".grid-list .grid").removeClass("active");$(".grid-list .list").addClass("active");
        }

        jQuery("body").on("click", ".grid", function() {
            var e = jQuery(this).closest(".grid-list");
            $.cookie('view-cata-list','no',  {expires: 1, path: '/'});
          	jQuery("body").removeClass("view-cata-list");
          	$(".grid-list .list").removeClass("active");
          	$(".grid-list .grid").addClass("active");
        }),jQuery("body").on("click", ".list", function() {
            var e = jQuery(this).closest(".view-mode");
            $.cookie('view-cata-list','yes', {expires: 1, path: '/'});
          	jQuery("body").addClass("view-cata-list");
          	$(".grid-list .grid").removeClass("active");
          	$(".grid-list .list").addClass("active");
        })
    }

    ,handleOrderFormQty : function(){
      jQuery("body").on("click",".global-product-info-qty-plus",function(){
        q = $(this).prev();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 0 : value;
        value++;
        q.val(value);
      });

      jQuery("body").on("click",".global-product-info-qty-minus",function(){
        q = $(this).next();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 1 : value;
        if(value > 1){
          value--;
          q.val(value);
        }
      });
    }

  	,effectNavigation : function(){ // Make hover effect of navigation
      	var dropdownMenuHoverTimeout = null;
        var dropdownMenuBlurTimeout = null;
          jQuery(".horizontal-menu .navbar-collapse .menu-list>li").hover(function(e){
            jQuery(this).find('>.dropdown-menu:not(.position-center), >.dropdown-menu li >.dropdown-menu').addClass("fadeInUp");
            let buf = jQuery(this);
            dropdownMenuBlurTimeout = setTimeout(function() {
              buf.find('>ul.dropdown-menu').addClass('hover');
            }, 150);
            clearTimeout(dropdownMenuHoverTimeout);
            jQuery('.horizontal-menu.dropdown-fix').addClass('dropdown-menu-hover');
            jQuery('.header-main').addClass('dropdown-menu-hover');
            jQuery('.wrap-breadcrumb').addClass('dropdown-menu-hover');
          jQuery('.dropdown-menu-overlay').addClass('dropdown-menu-hover');
        },function(e){
          jQuery('.dropdown-menu-overlay').removeClass('dropdown-menu-hover');
            clearTimeout(dropdownMenuBlurTimeout);
            
            dropdownMenuHoverTimeout = setTimeout(function() {
              jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInUp");
              jQuery('.horizontal-menu.dropdown-fix').removeClass('dropdown-menu-hover');
              jQuery('.header-main').removeClass('dropdown-menu-hover');
              jQuery('.wrap-breadcrumb').removeClass('dropdown-menu-hover');
            }, 400);
            jQuery(this).find('ul.dropdown-menu').removeClass('hover');
        });
      
      	jQuery(".top-account-holder").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});

      	jQuery(".currency-block").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});

      	jQuery(document).on('click','.searchbox>a',function(e){
            $(this).parents().find('.searchbox').toggleClass('open');
  		});

        jQuery('#city-phone-numbers').on("change", function(e) {
          var _newcity = jQuery(e.currentTarget).find(':selected').attr('value');
          $('#city-phone-number-label').html(_newcity);
        });

	}

	,megamenuWithTabs : function(){
		jQuery(".tab-title .title-item").hover(function(e){
			$('.title-item').removeClass('active');
			$('.tab-content-inner').removeClass('active');

			var _class = $(this).attr('data-id');
			var idclass = "." + _class;
			var e = jQuery(this);

			e.addClass('active');
			$(idclass).addClass('active');
		});

		jQuery(".mega-menu").mouseleave(function(){
			$('.title-item').removeClass('active');$('.title-item-1').addClass('active');
			$('.tab-content-inner').removeClass('active');$('.mm-tabs-1').addClass('active')
		});
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', '');
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }

  	,handleReviews: function() {
        /*SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();*/
    }

	,menuOnMobile : function(){

		jQuery(document).ready(function(e){
      		$('.mobile-version .mega-menu .dropdown-menu').removeAttr('style');
      		$('#no-heading').parent().removeClass('dropdown');
      	});

      	jQuery(document).on('click','.mobile-version .dropdown .expand',function(){
      		var e = $(this).parents().eq(1);
      		if(e.hasClass('col-item') || e.hasClass('mega-col'))
      		{
      			e.addClass('active').parent().addClass('sub-open');
      			console.log('has');
      		}
      		else{
      			$(this).parent().addClass('active').parent().addClass('sub-open');
      		}
      	});

		jQuery('#body-content').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','.back-prev-menu',function(){
			jQuery(this).parents('.dropdown-menu').first().removeClass('menu-mobile-open');
			jQuery(this).closest('.sub-open').first().removeClass('sub-open').children().removeClass('active');
		});

      	jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','.responsive-menu',function(e){
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery(".menu-mobile").toggleClass("opened");
			jQuery("html,body").toggleClass("menu-opened")
		});
      
      	jQuery(document).on('click','.sb-menu .expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("s-open")) {
                e.removeClass("s-open");
            } else {
                e.addClass("s-open");
            }
		})

		if( jQuery('.mobile-version .mega-menu .menu-proudct-carousel').length > 0 ){
			setTimeout(function(){
				jQuery('.mobile-version .mega-menu .menu-proudct-carousel .owl-stage-outer').before('<div class="back-prev-menu"><div class="demo-icon icon-left-open-1 d-lg-none"><span>Back</span></div></div>');
			},500);
		}

		jQuery(".vertical-menu .navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

		jQuery(document).on('click', '.mobile-version .menu-mobile .main-nav .expand', function(event) {
            var title = $(this).parent().find('a').first().text().trim().split('\n')[0];
            var e = jQuery(this).parents(".dropdown").children('.dropdown-menu').first();
        
            if (e.hasClass('menu-mobile-open')) {
                e.removeClass('menu-mobile-open');
                jQuery('.back-prev-menu').trigger('click');
                jQuery(this).removeClass('minus-sign'); // Remove the class that changes the icon to minus
            } else {
                e.addClass('menu-mobile-open');
                if (title.length > 0) {
                    e.children('.back-prev-menu').find('span').html(title);
                }
                jQuery(this).addClass('minus-sign'); // Add the class that changes the icon to minus
            }
        });


      	jQuery(document).on('click','.currency_wrapper',function(){
            if ($('.currency-block').hasClass("opened")) {
                $('.currency-block').removeClass("opened");
            } else {
                $('.currency-block').addClass("opened");
            }
		});

      	jQuery(document).on('click','.bc-toggle',function(){
			var e=jQuery(this);
            if (e.hasClass("opened")) {
                e.removeClass("opened");
            } else {
                e.addClass("opened");
            }
		});

		


		jQuery(document).on('click','.top-cart-holder.hover-dropdown .cart-target',function(){
			var e=jQuery(this);
			console.log('abc');
            if (e.hasClass("opened")) {
                e.removeClass("opened");
            } else {
                e.addClass("opened");
            }
		});
		
	}

	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}

  	,lookbooks_initor : function(){
		if( jQuery('.bc-lookbooks.lookbooks.margin-row').length > 0 ){

			if( 'undefined' === typeof Isotope ){
				console.log(" Isotope has not defined yet! ");
				return;
			}

			jQuery('.bc-lookbooks.lookbooks.margin-row').isotope({
			  itemSelector: '.look-item',
			  layoutMode: 'fitRows'
			});
		}
		if( jQuery('.bc-lookbooks.lookbooks.look-slider').length > 0 ){

			if( 'undefined' === typeof Swiper ){
				console.log(" Swiper has not defined yet! ");
				return;
			}

          	$('body').addClass('carousel-lookbook');

            var swiper_look = new Swiper('.lookbooks-wrapper.look-slider', {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                pagination: '.swiper-pagination',
                paginationType: 'progress',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 30
            });
		}
	}

	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
	}

	,filterCatalogReplace : function(collectionUrl, filter_id){

		var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
		var val = value.substring(value.lastIndexOf('?'));

		collectionUrl = collectionUrl.replace(value, '');

		value = value.replace(val, '');
		value = value.replace('#', '');

		var value_arr = value.split('+');

		var current_arr = [];
		jQuery('#'+filter_id+' li.active-filter').each( function() {
		  current_arr.push(jQuery(this).attr('data-handle'));
		});

		jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
		jQuery('#'+filter_id+' li').removeClass('active-filter');

		for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
		  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
		}

		var new_data = value_arr.join('+')

		var new_url = collectionUrl+new_data+val;

		if( typeof AT_Filter != 'undefined' && AT_Filter ){
			AT_Filter.updateURL = true;
            AT_Filter.requestPage(new_url);
		}else{
			window.location = new_url;
		}

	}

	,filterCatalog : function(){
		var currentTags = ''
			,filters 	= jQuery('.advanced-filter');

		filters.each(function() {
			var el = jQuery(this)
				,group = el.data('group');

			if ( el.hasClass('active-filter') ) { //Remove class hidden
				el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
			}
		});
      
      	filters.on('click', function(e) {
        var el = $(this)
            ,group = el.data('group')
            ,url = el.find('a').attr('href')

        // Continue as normal if we're clicking on the active link
        if ( el.hasClass('active-filter') ) {
          return;
        }
        
          var _logic = jQuery(".page-cata").data('logic');
          
          if( _logic ){
            // Get active group link (unidentified if there isn't one)
            activeTag = $('.active-filter[data-group="'+ group +'"]');

            // If a tag from this group is already selected, remove it from the new tag's URL and continue
            if ( activeTag && activeTag.data('group') === group ) {
              e.preventDefault();
              activeHandle = activeTag.data('handle') + '+';

              // Create new URL without the currently active handle
              url = url.replace(activeHandle, '');

              window.location = url;
            }
          }

        
      });

      jQuery('.style-accordion').on('click', '.sb-filter', function(n){ // Handle accordion in sidebar filter
        $(this).toggleClass('accordion-active');
        $(this).find('.advanced-filters').slideToggle('slow');
      });
      
      jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

			var filter_id = jQuery(this).attr('id');
			filter_id = filter_id.replace('clear-', '');

			var collectionUrl = window.location.href;

			if(collectionUrl.match(/\?/)){
				var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

				if(string.match(/\//)){
					var str_replace = string.replace(/\//, '');
					collectionUrl = collectionUrl.replace(string, '');
					collectionUrl = collectionUrl+str_replace;
					AT_Main.filterCatalogReplace(collectionUrl, filter_id);
				}
				else{
					AT_Main.filterCatalogReplace(collectionUrl, filter_id);
				}
			}
			else{
				var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

				collectionUrl = collectionUrl.replace(value, '');  

				value = value.replace('#', '');

				var value_arr = value.split('+');

				var current_arr = [];
				jQuery('#'+filter_id+' li.active-filter').each( function() {
				  current_arr.push(jQuery(this).attr('data-handle'));
				});

				jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
				jQuery('#'+filter_id+' li').removeClass('active-filter');

				for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
				  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
				}

				var new_data = value_arr.join('+')

				var new_url = collectionUrl+new_data;

				if( typeof AT_Filter != 'undefined' && AT_Filter ){
					AT_Filter.updateURL = true;
		            AT_Filter.requestPage(new_url);		
				}else{
					window.location = new_url;
				}
			}

      });
    }
      
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
  	}
      
    ,singleProductHomepage: function(){
      $('.single-gallery-thumbs .horizontal-thumb').on('click', function () {
        var e = $('.single-gallery-thumbs .horizontal-thumb');
        var img_big = $('.big-grid-item .featured-image');
        var img_thumb = $(this).find('.slick-image-thumb').attr('src');
        img_big.attr('src', img_thumb);

        if (e.hasClass('active')) {
          e.removeClass('active');
          $(this).addClass('active');
        } else {
          $(this).addClass('active');
        }
      })
    }
      
    ,shippingCalculator: function(){
      $('#shipping-calculator .shipping-title').on('click', function () {
        var e = $('#shipping-calculator .shipping');

        if (e.hasClass('hide')) {
          e.removeClass('hide');
        } else {
          e.addClass('hide');
        }
      })
    }

  	,switchImgProduct: function() {
    	$('.product-wrapper .swatch-element > input').on('change', function(e){
          	e.stopPropagation();
          	var imgUrl = $(this).data("swatch-image"),
                parent = $(this).parents('.product-wrapper'),
                imgElem = parent.find('.product-image img');
          	imgElem.parents('.product-image').addClass('img-loading');
          	imgElem.attr('src', imgUrl)
          	var fakeImg = new Image();
          	fakeImg.src = imgUrl;
            fakeImg.onload = function(event){
                imgElem.parents('.product-image').removeClass('img-loading');
            };
            fakeImg.onerror = function() {
                //Code for error loading
            };
        });
    }
      
    ,productGalleryImage: function(){
      jQuery('#gallery-images .thumb-imgs').click(function (e) {
        e.preventDefault();
        var img = $('#product-featured-image');
        var img_feature = $(this).find('.slick-image').attr('src');
        var img_zoom = $('#product-image .zoomImg');
        img.attr('src', img_feature);
        img.attr('data-zoom', img_feature);
        img_zoom.attr('src', img_feature);
        var e = $('#gallery-images .thumb-imgs');
        if (e.hasClass('active')) {
          e.removeClass('active');
          $(this).addClass('active');
        } else {
          $(this).addClass('active');
        }
        let data = $(this).attr('data-index');
        $('#product-image .featured-image').attr('data-fancybox-index',data);
      });
      
      jQuery('#product-featured-image')
      .wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: $(this).find('img').attr('data-zoom')
      });
      
      jQuery(".featured-image").on("click", function() { 
        $('[data-fancybox="preview"]').fancybox({
          margin : [44,0,22,0],
          buttons : [ 
            'slideShow',
            'share',
            'zoom',
            'fullScreen',
            'close'
          ],
          loop:true,
          thumbs   : {
            autoStart : true

          }
        });

      });
    }
      
    

    ,slickProductPage: function(){
        $('.slick-gallery-image').slick({
          infinite: false
          ,arrows: true
          ,fade: true
          ,dots: false
          ,autoplay: false
          ,mobileFirst: true
        });

        $('.slick-multi-rows').slick({
          rows: 2
          ,slidesPerRow: 2
          ,infinite: false
          ,arrows: true
          ,dots: false
          ,autoplay: false
          ,mobileFirst: true
        });

        jQuery('.slider-for-03').length && jQuery('.slider-for-03').slick({
          slidesToShow: 1
          ,slidesToScroll: 1
          ,arrows: true
          ,fade: true
          ,asNavFor: '.slider-thumbs-03'
          ,nextArrow: $('.slick-btn-03 .btn-next')
          ,prevArrow: $('.slick-btn-03 .btn-prev')
        });

        jQuery('.slider-thumbs-03').length && jQuery('.slider-thumbs-03').slick({
          infinite: false
          ,slidesToShow: 6
          ,slidesToScroll: 1
          ,asNavFor: '.slider-for-03'
          ,dots: false
          ,arrows: false
          ,focusOnSelect: true
        });

        jQuery('.slider-for-06').length && jQuery('.slider-for-06').slick({
          slidesToShow: 1
          ,slidesToScroll: 1
          ,vertical: false
          ,arrows: true
          ,fade: true
          ,asNavFor: '.slider-thumbs-06'
          ,nextArrow: $('.slick-btn-06 .btn-next')
          ,prevArrow: $('.slick-btn-06 .btn-prev')
        });

        jQuery('.slider-thumbs-06').length && jQuery('.slider-thumbs-06').slick({
          infinite: false
          ,slidesToShow: 6
          ,slidesToScroll: 1
          ,vertical: true
          ,asNavFor: '.slider-for-06'
          ,dots: false
          ,arrows: false
          ,focusOnSelect: true
        });
    }

  	,scareName : function(){
        var _name_height = 0;
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').each(function( index,value ){
          _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
        });
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').css('height',_name_height);
    }

  	,scareWidth : function(){
        var _name_width = 110;
        jQuery('.variants-wrapper .selector-wrapper').find('label').each(function( index,value ){
          _name_width = jQuery(value).width() > _name_width ? jQuery(value).outerWidth() : _name_width;
        });
        jQuery('.variants-wrapper .selector-wrapper').find('label').css('width',_name_width);
      	jQuery('.swatch.size').find('.header').css('width',_name_width);
      	jQuery('.swatch.color, .swatch.colour').find('.header').css('width',_name_width);
      	jQuery('.product-code span:first-child').css('width',_name_width);
      	jQuery('.product-qty, .quantity').find('label').css('width',_name_width);
    }

    ,scareScreen : function(){
      	if( typeof _bc_config == "undefined" ){
          	return;
      	}
      	var _current = this;

      	if( _bc_config.enable_title_blance == "true" ){
          	this.scareName();
      	}

      	jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }
        });
    }

	,init : function(){

      	if( typeof _bc_config == 'undefined' ){
           	 console.log( " _bc_config is undefined " );
           	 return ;
        }

        this.stickMenu();
        this.fixNavHeader();
		this.toTopButton();
		this.mailchipPopup();
      	this.toggleVerticalMenu();
      	this.toggleCartSidebar();
      	this.toggleFilterSidebar();
      	this.parallaxIt();
      	this.handleGridList();
      	this.effectNavigation();
      	this.megamenuWithTabs();
        this.fixButton();
		this.menuOnMobile();
		this.handleMenuMultiLine();
		this.fixTitle();
		this.filterCatalog();
        this.swatch();
      	this.singleProductHomepage();
      	this.shippingCalculator();
      	this.productGalleryImage();
      	this.switchImgProduct();
      	this.slickProductPage();
	}
}


/* Handle when window resize */
jQuery(window).resize(function() {

    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');

});

jQuery(document).ready(function($) {

	AT_Main.init();

  	/* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

});


//$(document).ready(function(){
/**
setTimeout(function(){
$('li').click(function() {
  $('#loadingclick').show();
  setTimeout(function(){
  $('#loadingclick').remove();
  }, 3000);
});
}, 1000);
**/

$(document).ready(function(){

// regular dropdown
setTimeout(function(){
var swatchOpt = $('[id*="swatch-group"]').length;
if (swatchOpt >= 1) {
	$('[id*="swatch-group"] > div > div > div > select').change(function() {
      $('[id*="swatch-group"]').after('<span id="loadingclick" style="padding-bottom:5px; font-weight:700;"> <img width="20px" src="https://cdn.shopify.com/s/files/1/0450/6330/7413/files/loading-bl.gif"/> Loading...</span>');

		setTimeout(function(){
		$('#loadingclick').remove();
		}, 5000);
	});
}
}, 5000);
  
//dropdown with image - King App
setTimeout(function(){
var swatchOpt = $('[id*="swatch-group"]').length;
if (swatchOpt >= 1) {
	$('[id*="swatch-group"] > div > div > div > ul > li:nth-child(n)').click(function() {
		$('[id*="swatch-group"]').after('<span id="loadingclick" style="padding-bottom:5px; font-weight:700;"> <img width="20px" src="https://cdn.shopify.com/s/files/1/0450/6330/7413/files/loading-bl.gif"/> Loading...</span>');

		setTimeout(function(){
		$('#loadingclick').remove();
		}, 5000);
	});
}
}, 1000);
  
//dropdown with image - Dynamic Options App
setTimeout(function(){
var swatchOpt = $('[id*="product-action"]').length;
if (swatchOpt == 2) {
	$('[id*="product-action"] > div > span:nth-child(n)').click(function() {
		$('.other-colors').after('<span id="loadingclick" style="padding-bottom:5px; font-weight:700;"> <img width="20px" src="https://cdn.shopify.com/s/files/1/0450/6330/7413/files/loading-bl.gif"/> Loading...</span>');

		setTimeout(function(){
		$('#loadingclick').remove();
		}, 5000);
	});
}
}, 1000);
  
//just image swatch + label
setTimeout(function(){
var swatchOpt = $('[id*="swatch-group"]').length;
if (swatchOpt >= 1) {
	$('[id*="swatch-group"] > div > fieldset > ul > li').click(function() {
		$('[id*="swatch-group"]').after('<span id="loadingclick" style="padding-bottom:5px; font-weight:700;"> <img width="20px" src="https://cdn.shopify.com/s/files/1/0450/6330/7413/files/loading-bl.gif"/> Loading...</span>');

		setTimeout(function(){
		$('#loadingclick').remove();
		}, 5000);
	});
}
}, 1000);
  
//   $('.product-wrapper .custom-collection-url').click(function(e) {
//   	e.preventDefault();
//     let collection_url = $(this).data('url');
//     let product_url = $(this).attr('href');
//     location.href = collection_url + product_url;
//   });
  
//   $('.select-item-per-page select').change(function() {
//   	localStorage.setItem('GTS_item_per_page', $(this).val());
//     let url = location.href;
//     if (url.includes('?')) {
//       location.href = url + '&item_per_page=' + $(this).val();
//     } else {
//       location.href = url + '?item_per_page=' + $(this).val();
//     }
//   });
});
 


//sticky header
setTimeout(function(){
  if ($(window).width() >= 992) {
  
    window.onscroll = function() {myFunction()};
    
    var navbar = document.getElementById("navbar");
    var blank = document.getElementById("blankspace");
    var logo = document.getElementById("GTlogo");
    var search = document.getElementById("search");
    var headericons = document.getElementById("header-icons");
    var menubar = document.getElementById("menubar");
    var menu3bars = document.getElementById("responsive-menu");
    //var sticky = menubar.offsetTop;
    var sticky = $("#menubar").offset().top + 50;  
      
    var isDescription = !$.trim( $('#readDescription').html() ).length;  
    if (isDescription == false) {
      var Mystickyoffer = $("#product-action").offset().top;  
      var MyOfferfloat = document.getElementById("floatoffer");
    }
    
    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
        menubar.classList.add("stickymenu");
        blank.classList.add("add-blank-space");
        logo.classList.add("stickylogo");
        search.classList.add("stickysearch");
        headericons.classList.add("stickyheadericons");
        menu3bars.classList.add("sticky3bards");
      } else {
        navbar.classList.remove("sticky");
        menubar.classList.remove("stickymenu");
        blank.classList.remove("add-blank-space");
        logo.classList.remove("stickylogo");
        search.classList.remove("stickysearch");
        headericons.classList.remove("stickyheadericons");
        menu3bars.classList.remove("sticky3bards");
      }
      
      if (isDescription == false) {
          if (window.pageYOffset >= Mystickyoffer) {
            MyOfferfloat.classList.add("stickyoffer");
          } else {
            MyOfferfloat.classList.remove("stickyoffer");
          }
          if($(window).scrollTop() + $(window).height() > ($(document).height() - 800) ) {
            MyOfferfloat.classList.remove("stickyoffer");
          }
      }
         
    }
  }
}, 1000);


// Enables help popover
$(function(){
  	/*$('[tooltip-data-toggle="tooltip"]').tooltip();*/
    $("[data-toggle=popover]").popover();
  var darkbg = document.getElementById("darkbg");
$('.myPopover').on('show.bs.popover', function () {
  darkbg.style.visibility = "visible";
  darkbg.style.opacity = "0.7";
});
$('.myPopover').on('hide.bs.popover', function () {
  darkbg.style.visibility = "hidden";
  darkbg.style.opacity = "0";
});
    $('#darkbg, .addcart-modal-box').click (function (e) {
        $('[data-toggle="popover"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
});
/*if(window.location.pathname == '/cart') {
	$('.BadgeInfo').append("<i class='icon-question-circle-o' style='font-size:12px;'></i>");
}*/
$('.featureSecLine').append("<i class='icon-question-circle-o' style='font-size:12px;'></i>");


//IE user message
browser = {};
if (/(Edge\/[0-9]{2})/i.test(navigator.userAgent)) {
    browser.agent = navigator.userAgent.match(/(Edge\/[0-9]{2})/i)[0].split("/")[0];
    browser.version = parseInt(navigator.userAgent.match(/(Edge\/[0-9]{2})/i)[0].split("/")[1]);
} else if (/(chrome\/[0-9]{2})/i.test(navigator.userAgent)) {
    browser.agent = navigator.userAgent.match(/(chrome\/[0-9]{2})/i)[0].split("/")[0];
    browser.version = parseInt(navigator.userAgent.match(/(chrome\/[0-9]{2})/i)[0].split("/")[1]);
} else if (/(firefox\/[0-9]{2})/i.test(navigator.userAgent)) {
    browser.agent = navigator.userAgent.match(/(firefox\/[0-9]{2})/i)[0].split("/")[0];
    browser.version = parseInt(navigator.userAgent.match(/(firefox\/[0-9]{2})/i)[0].split("/")[1]);
} else if (/(MSIE\ [0-9]{1})/i.test(navigator.userAgent)) {
    browser.agent = navigator.userAgent.match(/(MSIE\ [0-9]{1})/i)[0].split(" ")[0];
    browser.version = parseInt(navigator.userAgent.match(/(MSIE\ [0-9]+)/i)[0].split(" ")[1]);
} else if (/(Opera\/[0-9]{1})/i.test(navigator.userAgent)) {
    browser.agent = navigator.userAgent.match(/(Opera\/[0-9]{1})/i)[0].split("/")[0];
    browser.version = parseInt(navigator.userAgent.match(/(Opera\/[0-9]{1})/i)[0].split("/")[1]);
} else if (/(Trident\/[7]{1})/i.test(navigator.userAgent)) {
    browser.agent = "MSIE";
    browser.version = 11;
} else {
    browser.agent = false;
    browser.version = false;
}

if (/(Windows\ NT\ [0-9]{1}\.[0-9]{1})/.test(navigator.userAgent)) {
    browser.os = "Windows";

    switch (parseFloat(navigator.userAgent.match(/(Windows\ NT\ [0-9]{1}\.[0-9]{1})/)[0].split(" ")[2])) {
        case 6.0:
            browser.osversion = "Vista";
            break;
        case 6.1:
            browser.osversion = "7";
            break;
        case 6.2:
            browser.osversion = "8";
            break;
        default:
            browser.osversion = false;
    }
} else if (/(OS\ X\ [0-9]{2}\.[0-9]{1})/.test(navigator.userAgent)) {
    browser.os = "OS X";
    browser.osversion = navigator.userAgent.match(/(OS\ X\ [0-9]{2}\.[0-9]{1})/)[0].split(" ")[2];
} else if (/(Linux)/.test(navigator.userAgent)) {
    browser.os = "Linux";
    browser.osversion = false;
}

if (browser.agent === "MSIE" && browser.version <= 11) {
    var newDiv = document.createElement("div");
    newDiv.innerHTML = "Our website may not work properly with <b><i class='icon-internet-explorer'></i>Internet Explorer</b>. Please use a newer browser such as <a style='color:#3668cb' href='https://www.microsoft.com/en-us/edge' target='_blank'>Edge</a>, <a style='color:#3668cb' href='https://www.google.com/chrome/' target='_blank'>Chrome</a> or <a style='color:#3668cb' href='https://www.mozilla.org/en-US/firefox/new/' target='_blank'>Firefox</a>.";
  	newDiv.setAttribute("style", "background-color:yellow;padding:12px;text-align:center;");
    document.body.insertBefore(newDiv, document.body.firstChild);
} /*else { //TODO: Remove for Prod only added to show some flexibility and testing 
    var newDiv = document.createElement("div");
    newDiv.innerHTML = "<b>" + browser.agent + "</b> is <i>so</i> supported. You are using version: " + browser.version + ".";
    newDiv.setAttribute("style", "background-color:cyan;padding:12px;");
    document.body.insertBefore(newDiv, document.body.firstChild);
}*/


/** Privacy Page Tittle **/
$(document).ready(function() {
  if (window.location.href.indexOf("/policies/privacy-policy") != -1) {
   $("h1").css("fontSize", "16px");
  }
});


/** PDF MANUAL **/

	var ManualExist = $('img[src*="/manual.gif"]').length;
	if (ManualExist >= 1) {
		var ManualLink =  document.querySelector('img[src*="/manual.gif"]').parentElement;
		$('.ManualBadge').html('<span class="FeatureBadge"><a class="BadgeInfo" href='+ManualLink+'><div><span style="left: -2px;" class="m-0 p-0 position-absolute"><img src="//www.gtsimulators.com/cdn/shop/files/pdficon.svg?v=8452640195760682413" style="border-radius: 0px;" alt="PDF Manual"></span>Download Manual<br><span class="featureSecLine">Click to view product\'s manual</span></div></a></span>');
		
	}

 

/** SHORT DESCRIPTION **/
if (window.location.href.indexOf("/products/") != -1) {
  var FullDescription =  $('#tabs-description, .partsDesc')[0].innerHTML.substring(0,500);
  document.getElementById('FirstDesc').innerHTML = FullDescription;

/** Shortcut Copy SKU in product page **/
        const productCodeElement = document.querySelector(".product-code");
        const skuElement = document.getElementById("sku");
        const copyMessage = document.getElementById("copyMessage");

        productCodeElement.addEventListener("click", () => {
            const textToCopy = skuElement.textContent;
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    copyMessage.style.display = "inline";
                    setTimeout(() => {
                        copyMessage.style.display = "none";
                    }, 1000);
                })
                .catch(error => {
                    console.error("Failed to copy text: ", error);
                });
        });
}



/** REMOVE NUMBER FROM BREADCRUMB 
$('document').ready(function(){
    var isProd = !$.trim( $('.breadNameProd').html() ).length;
    var isCol  = !$.trim( $('.colTitle').html() ).length;
  
  	if (isProd == false) {
        BreadElement = $(".breadNameProd > a").html();
        $(".breadNameProd").children().html(BreadElement.substring(3));
	}

    //remove whole breadcrumb
    if (isProd == true) {
        //$("#breadcrumb").addClass("d-none");
	}
  	if (isCol == false) {
      if (document.location.href.indexOf('vendors') === -1){
        BreadElementColTittle = $(".ParentcolTitle > .colTitle").html();
        $(".ParentcolTitle").children().html(BreadElementColTittle.substring(3));

        $(".subcoltitle").each(function() {
                $(this).html($(this).html().substring(3));
        });
        //remove whole breadcrumb
        //$("#breadcrumb").addClass("d-none");
      }
    }  
});**/


/* CHANGE MANUFACTURER LINK URL */
$(document).ready(function() {
  $(".author a").each( function() {
   $(this).attr('href', $(this).attr("href").replace(/%20/g, "+"));
  });
});
 

/** DARK BG FOR SEARCH **/  
$(function() {
  $('#bc-product-search').focus(function(){
  //$('#bc-product-search').keypress(function(){
    $('#darkbg').addClass('dark');
    $('.navbar-form').addClass('updex');
  });

 $('#bc-product-search').on('blur', function() {
    $('#darkbg').removeClass('dark');
   $('.navbar-form').removeClass('updex');
 });
});
/*$('#bc-product-search').focus(function () { $(document.body).addClass('search-bar-open') }).blur(function () { $(document.body).removeClass('search-bar-open') });*/


/** ADD TO CART/QUOTE FLOATING CLONES **/
$(".addClone").click(function() {
    $('html,body').animate({
        scrollTop: $(".author").offset().top},
        'fast');
});
function addCartclone() {
  setTimeout(function() {
    document.getElementById("add-to-cart").click();
  }, 1000);
}
function addQuoteclone() {
  if (!window.dpoOptions.validateForm()) {
    event.stopPropagation();
    event.preventDefault()
 } else {
    document.getElementsByClassName("add-to-quote-btn")[0].click();
  }
}

/** ADD TO QUOTE HELPER **/
function laststep() {
  const button = document.querySelector('button.add-to-quote-btn');
  if (button) button.click();
}



/** CLICK LINK AND OPEN VIDEO **/
$(document).ready(function() {
 function autoClickMetaGroupButton() {
  if (window.location.href.indexOf('watchvideo') !== -1) {
    const buttonvid = document.querySelector('.m-video');
    if (buttonvid) {
      buttonvid.click();
    } else {
      console.log('Button with class name ".m-video" not found.');
    }
  }
}
autoClickMetaGroupButton();
});


/** EMPTY CART BUTTON **/
$("#EmptyCart").click(
function()
{
    window.location = "https://www.gtsimulators.com/cart/clear";
});


/*** READ MORE/LESS FUNCTION ***/
//$(function(){ /* to make sure the script runs after page load */
	$('.page-description').each(function(event){ /* select all divs with the item class */
		var max_length = 260; /* set the max content length before a read more link will be added */
		
    if ($(this).find('.skip-readmore').length) {
        return; // stop here, don't apply read more to this block
    }

		if($(this).html().length > max_length){ /* check for content length */
			var short_content 	= $(this).html().substr(0,max_length); /* split the content in two parts */
			var long_content	= $(this).html().substr(max_length);
			
			$(this).html(short_content+'<span class="points">... </span><a href="#" class="read_more">Read More (+)</a>'+'<span class="more_text" style="display:none;">'+long_content+'</span>'+'<a href="#" class="read_less"  style="display:none;"> Read Less (-) </a>'
			);
						 
			$(this).find('a.read_more').click(function(event){ /* find the a.read_more element within the new html and bind the following code to it */
 				event.preventDefault(); /* prevent the a from changing the url */
				$(this).hide(); /* hide the read more button */
				$(this).parents('.page-description').find('.more_text').show(); /* show the .more_text span */
				$('.points').hide();
				$('.read_less').show();

		 	});
	 	 	 $(this).find('a.read_less').click(function(event){ /* find the a.read_less element within the new html and bind the following code to it */
 				event.preventDefault(); /* prevent the a from changing the url */

				$(this).hide(); /* hide the read more button */
				$(this).parents('.page-description').find('.more_text').hide(); /* hide the .more_text span */
				$('.points').show();
				$('.read_more').show();
		 	});
		}
	});
//});

/** Hide Category Product Placeholder **/
setTimeout(function() {
    $('.categoryHolder').fadeOut('fast');
    $('.QuoteBtnPlaceholder').fadeOut('fast');
}, 2000);


/** Delay More Images load **/
$(document).ready(function() {
    $('.more-view-image').show();
});


/** PDF GENERATOR **/
function demoFromHTML() {
    const productPdfElem = document.getElementById('product-pdf');
    
    productPdfElem.style.display = 'block';

    const pdfWidth = 400;
    productPdfElem.style.width = pdfWidth + "pt";

    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'letter'
    });

    const source = productPdfElem;

    pdf.html(source, {
        margin: [40, 40, 40, 40],
        callback: function(pdf) {
            pdf.save('GTSimulators-Product-Details-.pdf');
            productPdfElem.style.display = 'none';
        },
        width: pdfWidth,
        scale: 1 // 100% scale
    });
}

/** GALLERY PRODUCT IMAGES - LEFT SIDE **/
if (window.location.href.indexOf("/products/") != -1) {
  var galleryImages = document.getElementById("gallery-images");
  var scrollDownButton = document.getElementById("scrollDownButton");

  document.getElementById("scrollDownButton").addEventListener("click", function() {
    var container = galleryImages; // Adjusted to target the ul element
    var imageHeight = container.querySelector(".slick-item").offsetHeight;
    container.scrollTo({
      top: container.scrollTop + imageHeight * 2,
      behavior: "smooth"
    });
  });

  document.getElementById("scrollUpButton").addEventListener("click", function() {
    var container = galleryImages; // Adjusted to target the ul element
    var imageHeight = container.querySelector(".slick-item").offsetHeight;
    container.scrollTo({
      top: container.scrollTop - imageHeight * 2,
      behavior: "smooth"
    });
  });

  function updateButtonColor() {
    var container = galleryImages;
    var isAtTop = container.scrollTop === 0;
    var isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;
    var isScrollable = container.scrollHeight > container.clientHeight;

    var scrollUpButton = document.getElementById("scrollUpButton");

    if (isAtTop) {

      scrollUpButton.style.visibility = "hidden";
      
    } else {
      scrollUpButton.style.color = "#3668cb";
      scrollUpButton.style.borderColor = "#3668cb";
      scrollUpButton.style.backgroundColor = "#FFF";
      scrollUpButton.style.visibility = "visible";
    }

    if (isScrollable && !isAtBottom) {
      scrollDownButton.style.color = "#3668cb";
      scrollDownButton.style.borderColor = "#3668cb";
      scrollDownButton.style.backgroundColor = "#FFF";
      scrollDownButton.style.visibility = "visible";
    } else {

      scrollDownButton.style.visibility = "hidden";
    }
  }

  galleryImages.addEventListener("scroll", updateButtonColor);
  window.addEventListener("resize", updateButtonColor); // Listen for window resize to update button color if necessary
  window.addEventListener("load", updateButtonColor); // Listen for page load to update button color initially
}





/*** MINIMUM QUANTITY FOR PRODUCT PAGE ****/
document.addEventListener('DOMContentLoaded', function() {
    const updateQuantityControl = () => {
        // Select the only quantity-product element
        const item = document.querySelector('.quantity-product');

        if (item) {
            const dataTags = item.getAttribute('data-tags');
            if (!dataTags) return;
            const tags = dataTags.split(',');

            // Find the first tag that starts with 'MIN'
            const minTag = tags.find(tag => tag.trim().startsWith('MIN'));
            const qtyInput = item.querySelector('.item-quantity');
            if (minTag) {
                const minClass = minTag.trim();
                const minValue = parseInt(minClass.substring(3), 10); // Extract numeric value

                // Set the input value to the minimum if current is less than minimum
                if (parseInt(qtyInput.value, 10) < minValue) {
                    qtyInput.value = minValue;
                }

                // Adding the minClass to the input element's class list
                qtyInput.classList.add(minClass);
                
                const currentValue = parseInt(qtyInput.value, 10);
                const downButton = item.querySelector('.qty-down');

                // Predict the next possible value
                const nextValue = currentValue - 1;

                // Update the down button class based on value predictions
                if (nextValue < minValue) {
                    downButton.classList.add('limitreached');
                } else {
                    downButton.classList.remove('limitreached');
                }
            }
        }
    };

    // Initial check and update
    updateQuantityControl();

    // Event listeners for quantity change buttons
    document.querySelectorAll('.qty-up, .qty-down').forEach(button => {
        button.addEventListener('click', function() {
            const isUp = this.classList.contains('qty-up');
            const input = document.querySelector('.quantity-product .item-quantity');
            let currentValue = parseInt(input.value, 10);

            // Predict the next value based on button pressed
            currentValue = isUp ? currentValue + 1 : currentValue - 1;

            // Set the predicted value to input temporarily to trigger the logic
            input.value = currentValue;
            updateQuantityControl();

            // Reset the value to original after logic calculation
            input.value = isUp ? currentValue - 1 : currentValue + 1;
        });
    });

    // Disable manual entry on the input field
    const qtyInput = document.querySelector('.quantity-product .item-quantity');
    if (qtyInput) {
        qtyInput.addEventListener('keydown', function(event) {
            event.preventDefault();
        });
    }

});


/*** bc.global.js file unified ***/
var AT_Slider ={

      owlSlider : function(){
        jQuery(".menu-proudct-carousel").length && jQuery(".menu-proudct-carousel").owlCarousel({
              nav: true,
              dots: false,
              items: 1,
              margin : 0,
              navText: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	jQuery(".big-product .image-list").length && jQuery('.big-product .image-list').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	jQuery(".image-carousel").length && jQuery('.image-carousel').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });
        
        jQuery('.big-image-thumbs').owlCarousel({
          nav     		: false
          ,dots  	 	: false
          ,items 		: 4
          ,margin 		: 0
          ,responsive 	: {
            0:{
              items: 3
            }
            ,480:{
              items: 3
            }
            ,768:{
              items: 4
            }
          }
        });

      	jQuery(".catalog-list").length && jQuery('.catalog-list').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 3
          	,margin		: 30
			      ,responsive : {
              	0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
                ,992:{
              		items: 3
                  	,nav	: false
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	setTimeout(function(){
          jQuery(".service-list-item").length && jQuery('.service-list-item').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,margin		: 0
			,responsive : {
              	0:{
                	items: 1
                }
            	,768:{
              		items: 2
            	}
              	,980:{
              		items: 3
            	}
                ,1024:{
              		items: 4
            	}
              	,1180:{
              		items: 6
                    ,nav	: false
                  	,autoWidth	: true
                  	,mouseDrag	: false
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
          });
        }, 1200);

      	jQuery(".gallery-image-thumb").length && jQuery('.gallery-image-thumb').owlCarousel({
            nav			: true
          	,dots 		: false
          	,margin		: 0
          	,mouseDrag	: false
          	,items    	: 6
			,responsive : {
              0:{
                items: 3
              }
              ,480:{
                items: 3
              }
              ,768:{
                items: 4
              }
              ,992:{
                items: 4
              }
              ,1024:{
                items: 6
              }
          	}
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

      	jQuery(".logo-list").length && jQuery('.logo-list').owlCarousel({
            nav			: false
          	,dots 		: true
          	,margin		: 30
          	,mouseDrag	: false
			,responsive : {
                0:{
                	items: 2
                }
              	,480:{
                	items: 3
                }
              	,768:{
                	items: 4
                }
              	,992:{
                	items: 5
                }
          	}
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

      	jQuery(".type-testimonial .testimonial").length && jQuery('.type-testimonial .testimonial').owlCarousel({
            nav			: true
          	,dots 		: false
			,items		: 1
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

	}

  	,init : function(){
      this.owlSlider();
    }

}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery.fn.extend({
  scrollToMe: function() {
    if (jQuery(this).length) {
      var top = jQuery(this).offset().top - 200;
      jQuery('html,body').animate({
        scrollTop: top
      }, 500);
    }
  },
});;

function addCart(){
  AT_Main.fixNoScroll();
  $('.cart-sb').toggleClass('opened');
  $('html,body').toggleClass('cart-opened');
}

function notifyAddCartFail($i){
  $.jGrowl($i,{
    life: 3000,
    position:'center'
  });
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();
  $('.loading').css("display","block");
  var $this = $(this);

  $this.addClass('disabled');

  var form = $this.parents('form');

  // Hide Modal
  $('.modal').modal('hide');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $('.loading').css("display","none");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  var product_name  = jqXHR.product_title
  ,product_image = jqXHR.image
  ,product_price = jqXHR.price
  ,product_quantity = jqXHR.quantity
  , product_variant = jqXHR.variant_title
  ,product_total_price = product_quantity * product_price;


  
    $('#layer-addcart-modal .addcart-modal-title').html(product_name);
    $('#layer-addcart-modal .addcart-modal-image').html('<img src="'+ Shopify.resizeImage(product_image,'220x') +'" alt="'+ product_name +'">');
    $('#layer-addcart-modal .addcart-modal-variant').html(product_variant);
    $('#layer-addcart-modal .addcart-modal-qty').html('<strong>Quantity:</strong>'+product_quantity+'');
    $('#layer-addcart-modal .addcart-modal-price').html('<strong>Total:</strong>'+ Shopify.formatMoney(product_total_price, _bc_config.money_format));
    $('#layer-addcart-modal').addClass('show');

  	// jQuery('body,html').animate({scrollTop:0},800,'swing');

  

  // Get the cart show in the cart box.
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');
  });

  
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
  $(this).removeClass('disabled');
  $('.add-to-cart').removeClass('disabled');
  $('.loading').css("display","none");
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

jQuery(document).ready(function($) {
  AT_Slider.init();
  
 	 $("body").on( 'click','.add-to-cart', addToCart );
  
})

